import React, { useState, useEffect } from "react";
import { useOrderDataFull } from "../useOrderDataFull";
import OrderCardTableRow from "./OrderCardTableRow";
import GoogleDriveLink from "./GoogleDriveLink";
import moreIcon from "../../images/icons/icons8-view-more-100.png";
import { useGeneric } from "../useGeneric";
import { prepOrder } from "../functions";
import OrderRowPretty from "./OrderRowPretty";
import OrderViewTable from "../main/OrderViewTable";

function OrdersOtherLink(props) {
  const { item, view, context } = props;
  const [customerOrderParams, setCustomerOrdersParams] = useState(null);
  // client orders
  const customerOrders = useGeneric({
    name: customerOrderParams?.customers_name && "customer-orders-list",
    query: {
      name: customerOrderParams?.customers_name,
      langMain: customerOrderParams?.language_main,
      langTo: customerOrderParams?.language_to,
    },
    update: customerOrderParams?.customers_name,
  });

  // console.log(customerOrders);
  // useOrderDataFull(customerOrderParams);

  // SHOW OTHER ORDERS FROM CUSTOMER
  useEffect(() => {
    if (customerOrders.loading) return;
    console.log("Pobrano", customerOrders, context);
    context.setModal((prev) => ({
      ...prev,
      content: (
        <div style={{ padding: "15px" }}>
          {/*customerOrders.data.length ? (
            <div className="flex driveMulti" style={{ fontSize: "14px" }}>
              <div>Wyszukaj łącznie trzy ostatnie zlecenia:</div>
              <GoogleDriveLink orders={customerOrders.data}></GoogleDriveLink>
            </div>
          ) : (
            ""
          )*/}
          {/* {JSON.stringify(customerOrders)} */}
          {customerOrders?.rows?.length ? (
            <OrderViewTable
              rows={customerOrders?.rows}
              loading={customerOrders?.loading}
              data={customerOrders?.rows}
              translatorView={true}
            />
          ) : (
            <>brak</>
          )}
          {/*
           // ? customerOrders.rows
            //     ?.map((item) => ({
            //       ...item,
            //     }))
            //     .reverse()
            //     .map((item, index) => (
            //       <OrderRowPretty item={item} index={index} />
                  
            //       // <OrderCardTableRow
            //       //   data={prepOrder(item)}
            //       //   view={view}
            //       //   archive={"customer"}
            //       // ></OrderCardTableRow>
            //     ))
            // : "brak"}
            */}
        </div>
      ),
      width: "screen",
    }));
  }, [customerOrderParams, customerOrders.loading]);

  return (
    <div
      title="Wszystkie zlecenia dla tego klienta"
      onClick={() => {
        //const shortCustomer = item.customers_name.length > 39 ? item.customers_name.slice(0,39) + "(...)" : item.customers_name;
        setCustomerOrdersParams(
          {
            customers_name: item.customers_name,
            language_main: item.language_main,
            language_to: item.language_to,
            // type: "search-all",
            // search: {
            //   language_main: {
            //     db: "o",
            //     value: item.language_main,
            //     standard: true,
            //     exact: true,
            //   },
            //   language_to: {
            //     db: "o",
            //     value: item.language_to,
            //     exact: true,
            //     standard: true
            //   },
            //   customers_name: {
            //     db: "o",
            //     standard: true,
            //     value: item.customers_name,
            //     exact: true,
            //   },
            // },
          } /*{
          count: 100,
          type: "both",
          language: item.language_main,
          language_to: item.language_to,
          repeat: false,
          client: item.customers_name,
        }*/
        );
        context.setModal((prev) => ({
          ...prev,
          show: !prev.show,
          content: <div style={{ padding: "15px" }}>Pobieranie...</div>,
          type: `${item.customers_name} | Wszystkie zlecenia > ${item.language_to}`,
          width: "wide",
        }));
      }}
    >
      <img src={moreIcon} alt="findOtherOrders"></img>
    </div>
  );
}

export default OrdersOtherLink;
